import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type HeartIconProps = CreateIconComponentProps;
export const HeartIcon: React.FC<HeartIconProps> = ({
  title = 'Heart',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      fill="currentColor"
      d="M20.204 14.283a1 1 0 0 0-1.408-1.421l1.408 1.42ZM12 21l-.704.71a1 1 0 0 0 1.408 0L12 21Zm-6.796-8.139a1 1 0 0 0-1.408 1.421l1.408-1.42ZM3.803 14.29a1 1 0 1 0 1.394-1.434L3.803 14.29ZM12 7.006l-.803.597a1 1 0 0 0 1.602.004L12 7.006Zm6.8 5.859a1 1 0 1 0 1.4 1.426l-1.4-1.426Zm-.004-.004-7.5 7.428 1.408 1.421 7.5-7.428-1.408-1.42Zm-6.092 7.428-7.5-7.428-1.408 1.421 7.5 7.428 1.408-1.42Zm-7.507-7.434a4 4 0 0 1-1.03-4.054l-1.91-.594a6 6 0 0 0 1.546 6.082l1.394-1.434Zm-1.03-4.054a4 4 0 0 1 3.148-2.756l-.336-1.971a6 6 0 0 0-4.721 4.133l1.91.594Zm3.148-2.756a4 4 0 0 1 3.882 1.558l1.606-1.194a6 6 0 0 0-5.824-2.335l.336 1.971Zm5.484 1.562a4 4 0 0 1 3.878-1.538l.34-1.97a6 6 0 0 0-5.816 2.306l1.598 1.202Zm3.878-1.538a4 4 0 0 1 3.137 2.75l1.91-.597a6 6 0 0 0-4.707-4.124l-.34 1.971Zm3.137 2.75a4 4 0 0 1-1.015 4.046l1.402 1.426a6 6 0 0 0 1.523-6.069l-1.91.596Z"
    />
  </CreateIconComponent>
);
